import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

import { isUserAuthorized } from "../../common/Authorization";
import { UserTypes } from "../../common/UserTypes";

const AddUser = lazy(() =>
  import("../../container/users/components/CreateUserForm")
);
const UsesList = lazy(() => import("../../container/users/UsersList"));
const UserDetails = lazy(() =>
  import("../../container/users/components/UserDetails")
);
const NotFound = lazy(() => import("../../container/pages/404"));

function UsersRoute() {
  return (
    <Routes>
      {/* Dashboard Admin , and Dashboard  Admin user routes routes */}
      {/* {isUserAuthorized([UserTypes.DASHBOARD_ADMIN_ID, UserTypes.DASHBOARD_USER_ID]) && (
        <>
          
      )} */}

      <Route path="/" element={<UsesList />} />
      <Route path="/:id/info" element={<UserDetails />} />
      <Route path="add-user" element={<AddUser />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default UsersRoute;
